import * as React from 'react';

import Definitionlist from '@src/components/Lists/DefinitionList';
import GridOneCol from '@src/components/Grid/GridOneCol';
import PageSection from '@src/components/PageSection';
import {graphql} from 'gatsby';

import {BasicDefinitionlistFragment} from '@graphql-types';

interface BasicDefinitionlistProps {
  basicDefinitionlistContent: BasicDefinitionlistFragment;
}

interface DefListItem {
  item_text: {
    html: string;
  };
}

const BasicDefinitionlist = ({
  basicDefinitionlistContent,
}: BasicDefinitionlistProps) => {
  // eslint-disable-next-line
  const {description_text, list_heading} = basicDefinitionlistContent.primary;
  const {items} = basicDefinitionlistContent;

  return (
    <PageSection>
      <GridOneCol gridType="small">
        {description_text && (
          <div dangerouslySetInnerHTML={{__html: description_text.html}} />
        )}
        <Definitionlist>
          {list_heading && <dt>{list_heading.text}</dt>}
          {items &&
            items.map(({item_text}, i) => {
              return (
                <dd
                  key={i}
                  dangerouslySetInnerHTML={{__html: item_text.html}}
                />
              );
            })}
        </Definitionlist>
      </GridOneCol>
    </PageSection>
  );
};

export default BasicDefinitionlist;

export const basicDefinitionFragment = graphql`
  fragment basicDefinitionlist on PrismicPageDataBodyDefinitionList {
    id
    slice_type
    primary {
      description_text {
        html
      }
      list_heading {
        text
      }
    }
    items {
      item_text {
        html
      }
    }
  }
`;
